<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu giải trình công</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Tiêu đề"
                          prop="employee_request.title"
                        >
                          <el-input
                            type="text"
                            v-model="mData.dataForm.employee_request.title"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            ref="title"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Phân loại"
                          prop="employee_request.type"
                        >
                          <el-select
                            disabled
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="mData.reselectEmployee">
                        <el-form-item
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employee_id
                            "
                            :disabled="!isSelectEmployee"
                            @input="forceUpdateUI"
                            @change="fn_reSelectEmployee"
                          >
                            <el-option
                              v-for="item in filteredRequestWorkExplanationEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select v-model="requestEmployeeFilter.branch_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả chi nhánh" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredBranchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select v-model="requestEmployeeFilter.department_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả phòng ban" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredDepartmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employeeApproval
                            "
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ?`${item.e.employee_no ? item.e.employee_no : ''} - ${item.e.administrative_info.name.full_name ? item.e.administrative_info.name.full_name : ''}`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Lý do"
                          prop="detail_request.request_reason_id"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.detail_request.request_reason_id
                            "
                          >
                            <el-option
                              v-for="item in mData.dataDefault
                                .listRequestReason"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ngày"
                          prop="detail_request.explained_start_date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="
                              mData.dataForm.detail_request.explained_start_date
                            "
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'dd/MM/yyyy' || 'dd-MM-yyyy'"
                            :picker-options="pickerOptionTo"
                            @change="fn_getShiftBySelectedDay"
                            @input="forceUpdateUI"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="listEmployeeShiftDetail.length > 0">
                        <el-form-item
                          label="Ca làm việc"
                          prop="detail_request.shift_id"
                        >
                          <el-radio-group
                            v-model="mData.dataForm.detail_request.shift_id"
                            @change="fn_changeShift"
                          >
                            <el-radio
                              class="mr-3"
                              v-for="(shift, index) in listEmployeeShiftDetail"
                              :key="index"
                              :label="shift.id"
                              >{{ shift.name }}</el-radio
                            >
                          </el-radio-group>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Cách giải trình công"
                          prop="detail_request.convert_work_method"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.detail_request.convert_work_method
                            "
                            @change="fn_checkAllowEnterWork"
                          >
                            <el-option
                              v-for="item in listMethod"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="3" v-if="mData.dataForm.detail_request.convert_work_method == 'AUTO' && isPassDay">
                        <el-form-item
                          label="Thời gian bắt đầu"
                          prop="detail_request.explained_start_date"
                        >
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.explained_start_date"
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'HH:mm dd/MM/yyyy' || 'HH:mm dd-MM-yyyy'"
                            :picker-options="pickerOptionTo"
                            @change="fn_calWorkPassDayShift"
                            @input="forceUpdateUI"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col md="3" v-if="mData.dataForm.detail_request.convert_work_method == 'AUTO' && isPassDay">
                        <el-form-item
                          label="Thời gian kết thúc"
                          prop="detail_request.explained_end_date"
                        >
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.explained_end_date"
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'HH:mm dd/MM/yyyy' || 'HH:mm dd-MM-yyyy'"
                            :picker-options="pickerOptionTo"
                            @change="fn_calWorkPassDayShift"
                            @input="forceUpdateUI"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col
                        md="6"
                        v-if="
                          mData.dataForm.detail_request.convert_work_method ==
                          'AUTO' && !isPassDay
                        "
                      >
                        <el-form-item label="Thời gian làm việc" prop="detail_request.time_work">
                          <el-time-picker
                            is-range
                            v-model="mData.dataForm.detail_request.time_work"
                            range-separator="_"
                            start-placeholder="Bắt đầu"
                            end-placeholder="kết thúc"
                            format="HH:mm"
                            @change="fn_calWork"
                          >
                          </el-time-picker>
                        </el-form-item>
                      </b-col>
                      <b-col
                        :md="
                          mData.dataForm.detail_request.convert_work_method ==
                          'AUTO'
                            ? 6
                            : 12
                        "
                        v-if="mData.dataForm.detail_request.convert_work_method"
                      >
                        <el-form-item
                          label="Công"
                          :prop="mData.dataForm.detail_request.convert_work_method == 'INPUT' ? 'detail_request.number_of_works' : ''"
                        >
                          <el-input-number
                            type="number"
                            v-model="mData.dataForm.detail_request.number_of_works"
                            :disabled="
                              mData.dataForm.detail_request
                                .convert_work_method == 'AUTO'
                            "
                            :precision="2"
                            :step="0.1"
                            :min="0"
                            :max="numberWordDay"
                            :controls="false"
                            @focus="fn_resetNumberWorkDay"
                            @input="forceUpdateUI"
                          ></el-input-number>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ghi chú"
                          prop="employee_request.content"
                        >
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        :disabled="!createRequest"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestWorkAdditionApi from "../../../../moduleApi/EmployeeRequestWorkAdditionApi";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      typeReq: "WORK_EXPLANATION",
      number_of_works: undefined,
      listMethod: [
        {
          label: "Nhập giờ để quy đổi ra công",
          value: "AUTO",
        },
        {
          label: "Nhập công",
          value: "INPUT",
        },
      ],
      isPassDay: false,
      numberWordDay: 0,
    };
  },

  computed: {
    filteredDepartmentList() {
      return (this.mData.dataDefault.listDepartment || []).filter(
        dept => dept.company_id === this.currentCompany.id
      );
    },
    filteredBranchList() {
      return (this.mData.dataDefault.listBranch || []).filter(
        branch => branch.company_id === this.currentCompany.id
      );
    }
  },

  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployeeWorkExplanation();
      this.fn_getListEmployeeRequestReason(this.typeReq);
      await this.fn_getListEmployeeApprovedQLTT();
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return;
      const allEmployees = [
        ...(this.mData.dataDefault.listNhanVien || []),
        ...(this.mData.dataDefault.listEmployeeWorkExplanation || []),
      ];
      const selectedEmployee = allEmployees.find(
        (item) => String(item.id) === String(employeeId)
      );
      if (!selectedEmployee) return;

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee);
      const departmentIds = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter((id) => !!id)
        ),
      ];
      const branchIds = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter((id) => !!id)
        ),
      ];

      this.requestEmployeeFilter.department_ids = departmentIds;
      this.requestEmployeeFilter.branch_ids = branchIds;
      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut();
      });
    },

    fn_resetNumberWorkDay() {
      // if (this.mData.dataForm.detail_request.number_of_works < 0) {
      //   this.mData.dataForm.detail_request.number_of_works = 0;
      // }
      // this.mData.dataForm.detail_request.number_of_works = "";
    },

    async fn_getShiftBySelectedDay() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        window.toastr.warning("Vui lòng chọn Nhân viên");
      } else {
        if (this.mData.dataForm.detail_request.shift_id) {
          this.mData.dataForm.detail_request.shift_id = undefined;
        }
        if (this.mData.dataForm.detail_request.convert_work_method) {
          this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.convert_work_method").resetField();
        }
        if (this.mData.dataForm.detail_request.explained_end_date) {
          this.mData.dataForm.detail_request.explained_end_date = undefined;
        }
        if (this.mData.dataForm.detail_request.time_work) {
          this.mData.dataForm.detail_request.time_work = undefined;
        }
        if (this.mData.dataForm.detail_request.number_of_works) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        }
        this.fn_initDataShift();
      }
    },

    fn_checkAllowEnterWork() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        window.toastr.warning(
          "Vui lòng chọn Nhân viên"
        );
        if (this.mData.dataForm.detail_request.number_of_works) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        }
        if (this.mData.dataForm.detail_request.convert_work_method) {
          this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.convert_work_method").resetField();
        }
      } else if (!this.mData.dataForm.detail_request.explained_start_date) {
        window.toastr.warning(
          "Vui lòng chọn ngày giải trình công"
        );
        if (this.mData.dataForm.detail_request.number_of_works) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        }
        if (this.mData.dataForm.detail_request.convert_work_method) {
          this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.convert_work_method").resetField();
        }
      } else if (!this.mData.dataForm.detail_request.shift_id) {
        window.toastr.warning(
          "Vui lòng chọn Ca làm việc"
        );
        if (this.mData.dataForm.detail_request.number_of_works) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        }
        if (this.mData.dataForm.detail_request.convert_work_method) {
          this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.convert_work_method").resetField();
        }
      }
      this.mData.dataForm.detail_request.number_of_works = 0;
      if (this.mData.dataForm.detail_request.convert_work_method == "AUTO") {
        this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.number_of_works").resetField();
      }
      if (this.mData.dataForm.detail_request.time_work) {
        this.mData.dataForm.detail_request.time_work = undefined;
      }
    },

    async fn_reSelectEmployee() {
      if (this.mData.dataForm.employee_request.employee_id) {
        await this.fn_getListEmployeeApprovedQLTT(this.mData.dataForm.employee_request.employee_id, false);
        this.fn_syncRequestOrgFilterByEmployee(
          this.mData.dataForm.employee_request.employee_id
        );
        this.mData.validForm.employee_request.employee_id = [];
        this.$nextTick(() => {
          if (this.$refs["myForm"]) {
            this.$refs["myForm"].clearValidate("employee_request.employee_id");
          }
        });
      }
      this.listEmployeeShiftDetail = [];
      if (this.mData.dataForm.detail_request.shift_id) {
        this.mData.dataForm.detail_request.shift_id = undefined;
      }
      if (this.mData.dataForm.detail_request.convert_work_method) {
        this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.convert_work_method").resetField();
      }
      if (this.mData.dataForm.detail_request.explained_start_date) {
        this.mData.dataForm.detail_request.explained_start_date = undefined;
      }
      if (this.mData.dataForm.detail_request.explained_end_date) {
        this.mData.dataForm.detail_request.explained_end_date = undefined;
      }
      if (this.mData.dataForm.detail_request.time_work) {
        this.mData.dataForm.detail_request.time_work = undefined;
      }
      if (this.mData.dataForm.detail_request.number_of_works) {
        this.mData.dataForm.detail_request.number_of_works = 0;
      }
    },

    // Change shift reset input field
    fn_changeShift() {
      if (this.mData.dataForm.detail_request.number_of_works) {
        this.mData.dataForm.detail_request.number_of_works = 0;
      }
      if (this.mData.dataForm.detail_request.time_work) {
        this.mData.dataForm.detail_request.time_work = undefined;
      }
      if (this.mData.dataForm.detail_request.explained_end_date) {
        this.mData.dataForm.detail_request.explained_end_date = undefined;
      }
      if (this.mData.dataForm.detail_request.shift_id && !this.mData.dataForm.detail_request.explained_start_date) {
        window.toastr.warning("Vui lòng chọn Ngày giải trình công");
        this.mData.dataForm.detail_request.shift_id = undefined;
        this.$refs["myForm"].fields.find((f) => f.prop == "detail_request.shift_id").resetField();
      } else {
        let todayShiftTime = [];
        this.fn_checkHasShiftAndNumberWordDay(this.mData.dataForm.detail_request.explained_start_date, todayShiftTime);
      }
      this.forceUpdateUI();
    },
    //Form
    async fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.title =
              this.mData.dataForm.employee_request.title.trim();
            this.mData.dataForm.employee_request.content =
              this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id =
              this.currentCompany.id;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 1;
            this.mData.dataForm.employee_request.approval_users =
              listApprovalUser;

            const t = new Date(this.mData.dataForm.detail_request.explained_start_date);
            if (
              this.mData.dataForm.detail_request.convert_work_method == "AUTO" && !this.isPassDay
            ) {
              const t1 = this.mData.dataForm.detail_request.time_work[0];
              const t2 = this.mData.dataForm.detail_request.time_work[1];
              this.mData.dataForm.detail_request.explained_start_date =
                new Date(
                  t.getFullYear(),
                  t.getMonth(),
                  t.getDate(),
                  t1.getHours(),
                  t1.getMinutes()
                ).toISOString();
              this.mData.dataForm.detail_request.explained_end_date = new Date(
                t.getFullYear(),
                t.getMonth(),
                t.getDate(),
                t2.getHours(),
                t2.getMinutes()
              ).toISOString();
            } else if (
              this.mData.dataForm.detail_request.convert_work_method == "INPUT"
            ) {
              // console.log("this.mData.dataForm.detail_request.explained_start_date", t);
              this.mData.dataForm.detail_request.explained_start_date =
                new Date(
                  t.getFullYear(),
                  t.getMonth(),
                  t.getDate(),
                  0,
                  0
                ).toISOString();
              this.mData.dataForm.detail_request.explained_end_date = new Date(
                t.getFullYear(),
                t.getMonth(),
                t.getDate(),
                23,
                59
              ).toISOString();
            }
            if (this.mData.dataForm.detail_request.number_of_works == 0) {
              window.toastr.warning("Công phải lớn hơn 0 mới có thể tạo yêu cầu");
            } else {
              let dataEmployeeRequest = this.mData.dataForm.employee_request;
              let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;

              if (type == "create") {
                const res = await EmployeeRequestApi.create(dataEmployeeRequest);
                dataEmployeeRequestDetail.id = res.result;
                await EmployeeRequestWorkAdditionApi.create(
                  dataEmployeeRequestDetail
                );
                if (
                  this.mData.dataDefault.listFeature.includes("FT1001") ||
                  this.mData.dataDefault.listFeature.includes("FT1002")
                ) {
                  this.$router.push({
                    name: "Admin-ManageRequests-RequestsWaitingForApproval",
                  });
                }
                this.fn_resetForm();
                this.fn_checkHasEmployee();
              }
            }
          } catch (error) {
            console.log("error", error);
            // window.toastr.error("Tạo yêu cầu thất bại");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_checkQueryRoute() {
      if (
        this.$router.currentRoute.query.day &&
        this.$router.currentRoute.query.month &&
        this.$router.currentRoute.query.year
      ) {
        const dateString = MethodService.formatDateYYYYMMDD(
          new Date(
            this.$router.currentRoute.query.year,
            this.$router.currentRoute.query.month - 1,
            this.$router.currentRoute.query.day
          ),
          "date"
        );
        this.mData.dataForm.detail_request.explained_start_date = new Date(dateString);
        this.mData.dataForm.detail_request.explained_end_date = new Date(dateString);
      }
      if (this.$router.currentRoute.query.employee_id) {
        this.mData.dataForm.employee_request.employee_id = this.$router.currentRoute.query.employee_id;
        this.fn_syncRequestOrgFilterByEmployee(
          this.mData.dataForm.employee_request.employee_id
        );
        this.mData.validForm.employee_request.employee_id = [];
        await this.fn_initDataShift();
        if (this.mData.dataForm.detail_request.explained_start_date) {
          this.mData.validForm.detail_request.explained_start_date = [];
        }
        if (this.$router.currentRoute.query.shift_id) {
          this.mData.dataForm.detail_request.shift_id = this.$router.currentRoute.query.shift_id;
          this.mData.validForm.detail_request.shift_id = [];
          let todayShiftTime = [];
          this.fn_checkHasShiftAndNumberWordDay(this.mData.dataForm.detail_request.explained_start_date, todayShiftTime);
        }
      }
      await this.forceUpdateUI();
    },
  },

  async created() {
    this.mData.dataForm.employee_request.type = "WORK_EXPLANATION";
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployee('WORK_EXPLANATION');
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
    await this.fn_checkQueryRoute();
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css"></style>
